// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__jV-KW","author":"Table_author__1JJue","authorImage":"Table_authorImage__2-_Bc","unreadRow":"Table_unreadRow__3JKlj"};